import { faRotate } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Space } from "antd"
import { ServerState, workareaIdsWithUnsyncedItems } from "./itemModel"
import { useContext } from "react"
import { ItemsContext } from "./ItemsRoot"

type Props = {
  workareaId: number
}

const canSync = (unsyncedWorkareaIds: number[], workareaId: number): boolean => {
  return unsyncedWorkareaIds.includes(workareaId)
}

const RefreshPricingButton = ({ workareaId }: Props) => {
  const { jobItemsQuery, changeSet, jobData, dispatch } = useContext(ItemsContext)

  if (jobData.jobIsSold || jobItemsQuery.isLoading || jobData.budgets.length === 0) {
    return <></>
  }

  const serverState: ServerState = {
    workareaItems: jobItemsQuery.data?.estimatedItems ?? [],
    catalogItems: jobItemsQuery.data?.catalogItems ?? [],
    templateItems: jobItemsQuery.data?.templateItems ?? [],
  }
  const unsyncedWorkareaIds = workareaIdsWithUnsyncedItems(changeSet, serverState, jobData.budgets, jobData.jobIsSold)
  const disabled = !canSync(unsyncedWorkareaIds, workareaId)

  const handleClick = () => {
      dispatch({type: 'SYNC_WORKAREA_PRICING', serverState, budgets: jobData.budgets, workareaId})
  }

  return <Button size="large" disabled={disabled} onClick={handleClick}>
    <Space><FontAwesomeIcon icon={faRotate} />Refresh Pricing</Space>
  </Button>
}

export default RefreshPricingButton
